import { render, staticRenderFns } from "./CopyToClipboard.vue?vue&type=template&id=64c4ce7d&scoped=true&"
import script from "./CopyToClipboard.vue?vue&type=script&lang=ts&"
export * from "./CopyToClipboard.vue?vue&type=script&lang=ts&"
import style0 from "./CopyToClipboard.vue?vue&type=style&index=0&id=64c4ce7d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c4ce7d",
  null
  
)

export default component.exports